module.exports = __webpack_public_path__ + "img/sv32.c209611c.svg";